import { forwardRef } from 'react'
import type { HTMLAttributes } from 'react'
import styles from './GlassCard.module.css'

export const GlassCard = forwardRef<HTMLDivElement, HTMLAttributes<HTMLDivElement>>(
  function GlassCard({ className = '', ...props }, ref) {
    return (
      <div
        ref={ref}
        className={`${styles.card} ${className}`.trim()}
        {...props}
      />
    )
  },
)
